import "./Navbar.css";

const Navbar = () => {
  return (
    <nav className="navbar">
      <div className="banner">
        <h1>Výroba, predaj a servis sedacích súprav s&nbsp;viac&nbsp;ako&nbsp;30&nbsp;ročnou&nbsp;tradíciou</h1>
      </div>

      <div className="container">
        <div className="logo">
          <a href="https://interstyle.sk/">
            <img
              width="112.94"
              height="40"
              src="/data/photos/logo/interstyle-logo.svg"
              alt="Interstyle"
            />
          </a>
        </div>

        {/* Namiesto navLinkov len statický text */}
        <div className="nav-elements">
          <h2>Sedacie súpravy ihneď&nbsp;k&nbsp;odberu</h2>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
